import * as React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

type ButtonProps = React.ComponentProps<typeof Button>;

/**
 * Props for the RefreshButton component
 */
interface RefreshButtonProps extends ButtonProps {
  /** Whether the button is in a loading/refreshing state */
  isLoading?: boolean;
}

/**
 * Button component for refresh/sync operations.
 * Always shows the RefreshCw icon, which animates when loading.
 */
export function RefreshButton({
  isLoading = false,
  disabled,
  children,
  ...props
}: RefreshButtonProps) {
  return (
    <Button disabled={disabled ?? isLoading} {...props}>
      <RefreshCw className={`h-4 w-4 ${children ? 'mr-2' : ''} ${isLoading ? 'animate-spin' : ''}`} />
      {children}
    </Button>
  );
}
